var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembersuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 95.5,
    r: 94.5,
    fill: "#EBFFEB",
    fillOpacity: 0.9,
    stroke: "#39C136"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_67751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.001 33.7502C62.191 33.7502 34.751 61.1902 34.751 95.0002C34.751 128.81 62.191 156.25 96.001 156.25C129.811 156.25 157.251 128.81 157.251 95.0002C157.251 61.1902 129.811 33.7502 96.001 33.7502ZM79.4022 121.277L57.4135 99.2878C55.0247 96.899 55.0247 93.0402 57.4135 90.6515C59.8022 88.2627 63.661 88.2627 66.0497 90.6515L83.751 108.292L125.891 66.1515C128.28 63.7627 132.138 63.7627 134.527 66.1515C136.916 68.5402 136.916 72.399 134.527 74.7877L88.0385 121.277C85.711 123.665 81.791 123.665 79.4022 121.277Z",
    fill: "#1BB718"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_67751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 147,
    fill: "white",
    transform: "translate(22.5 21.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersuccess);
export default __webpack_public_path__ + "static/media/membersuccess.264d2dcffbc293ece111505b6b01c70b.svg";
export { ForwardRef as ReactComponent };